@if (isLocalUrl()) {
    <img [src]="iconUrl()" (error)="loadFallbackIcon()" alt="" aria-hidden="true">
} @else {
    <img [url]="iconUrl()" core-external-content alt="" aria-hidden="true" [component]="linkIconWithComponent() ? modname : null"
        [componentId]="linkIconWithComponent() ? componentId : null" (error)="loadFallbackIcon()">
}
